var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccounting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.005,
    height: 23.929,
    viewBox: "0 0 24.005 23.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-647 -92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,1a12.124,12.124,0,0,0-4.556.8C1.452,2.223,1,2.719,1,3s.452.777,1.444,1.2A12.124,12.124,0,0,0,7,5a12.124,12.124,0,0,0,4.556-.8C12.548,3.777,13,3.281,13,3s-.452-.777-1.444-1.2A12.124,12.124,0,0,0,7,1M7,0c3.866,0,7,1.343,7,3S10.866,6,7,6,0,4.657,0,3,3.134,0,7,0Z",
    transform: "translate(647 92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,16a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V15.5A.5.5,0,0,1,0,16Z",
    transform: "translate(647.5 95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V6.5A.5.5,0,0,1,0,7Z",
    transform: "translate(660.5 95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14869.281-4031.047c-4.969,0-7.037-1.989-7.123-2.074a.5.5,0,0,1,0-.707.5.5,0,0,1,.705-.006,5.441,5.441,0,0,0,1.49.891,12.392,12.392,0,0,0,4.932.9,10.5,10.5,0,0,0,4.612-.871,3.559,3.559,0,0,0,1.206-.856l0,0,.809.587C14875.843-4033.1,14874.3-4031.047,14869.281-4031.047Z",
    transform: "translate(-14215 4135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14869.281-4031.047c-4.969,0-7.037-1.989-7.123-2.074a.5.5,0,0,1,0-.707.5.5,0,0,1,.705-.006,5.441,5.441,0,0,0,1.49.891,12.392,12.392,0,0,0,4.932.9,10.5,10.5,0,0,0,4.612-.871,3.559,3.559,0,0,0,1.206-.856l0,0,.809.587C14875.843-4033.1,14874.3-4031.047,14869.281-4031.047Z",
    transform: "translate(-14215 4132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14869.04-4031.018a12.863,12.863,0,0,1-5.388-.927,3.184,3.184,0,0,1-1.6-1.323l.908-.417-.006-.013c.01.018.96,1.68,6.1,1.68q.567,0,1.2-.028h.022a.5.5,0,0,1,.5.477.5.5,0,0,1-.477.522Q14869.65-4031.018,14869.04-4031.018Z",
    transform: "translate(-14215 4138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14869.04-4031.018a12.863,12.863,0,0,1-5.388-.927,3.184,3.184,0,0,1-1.6-1.323l.908-.417-.006-.013c.01.018.96,1.68,6.1,1.68q.567,0,1.2-.028h.022a.5.5,0,0,1,.5.477.5.5,0,0,1-.477.522Q14869.65-4031.018,14869.04-4031.018Z",
    transform: "translate(-14215 4141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14869.04-4031.018a12.863,12.863,0,0,1-5.388-.927,3.184,3.184,0,0,1-1.6-1.323l.908-.417-.006-.013c.01.018.96,1.68,6.1,1.68q.567,0,1.2-.028h.022a.5.5,0,0,1,.5.477.5.5,0,0,1-.477.522Q14869.65-4031.018,14869.04-4031.018Z",
    transform: "translate(-14215 4144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,1a12.124,12.124,0,0,0-4.556.8C1.452,2.223,1,2.719,1,3s.452.777,1.444,1.2A12.124,12.124,0,0,0,7,5a12.124,12.124,0,0,0,4.556-.8C12.548,3.777,13,3.281,13,3s-.452-.777-1.444-1.2A12.124,12.124,0,0,0,7,1M7,0c3.866,0,7,1.343,7,3S10.866,6,7,6,0,4.657,0,3,3.134,0,7,0Z",
    transform: "translate(657 104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14869.281-4031.047c-4.969,0-7.037-1.989-7.123-2.074a.5.5,0,0,1,0-.707.5.5,0,0,1,.705-.006,5.441,5.441,0,0,0,1.49.891,12.392,12.392,0,0,0,4.932.9,10.5,10.5,0,0,0,4.612-.871,3.559,3.559,0,0,0,1.206-.856l0,0,.809.587C14875.843-4033.1,14874.3-4031.047,14869.281-4031.047Z",
    transform: "translate(-14205.006 4146.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14869.281-4031.047c-4.969,0-7.037-1.989-7.123-2.074a.5.5,0,0,1,0-.707.5.5,0,0,1,.705-.006,5.441,5.441,0,0,0,1.49.891,12.392,12.392,0,0,0,4.932.9,10.5,10.5,0,0,0,4.612-.871,3.559,3.559,0,0,0,1.206-.856l0,0,.809.587C14875.843-4033.1,14874.3-4031.047,14869.281-4031.047Z",
    transform: "translate(-14205.006 4143.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V6.5A.5.5,0,0,1,0,7Z",
    transform: "translate(670.505 106.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V6.5A.5.5,0,0,1,0,7Z",
    transform: "translate(657.505 106.75)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.2d1bf0b051dc1db7f8accdbb3c6d0f7a.svg";
export { ForwardRef as ReactComponent };